import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { defaultTheme } from 'lib/themes';
import Container from '../components/container';
import WidthController from '../components/width-controller';
import { styles } from './final-page/final-page.styles';

const SubmissionErrorPage = ({ classes }) => {
  return (
    <Container
      title="It's time for your refill"
      footer={<Box height={55} backgroundColor={defaultTheme.palette.primary.teal} />}
    >
      <WidthController className={classes.container}>
        <Stack direction="column" spacing={5} data-qa-id="submitting-error-page">
          <Typography
            className={classes.message}
            color={defaultTheme.palette.primary.teal}
            type="title"
            data-qa-id="title"
          >
            Ooops! There was a problem processing your order. Someone from our pharmacy will call
            you to complete your order.
          </Typography>
        </Stack>
      </WidthController>
    </Container>
  );
};

export default compose(withStyles(styles))(SubmissionErrorPage);
